/* eslint-disable no-underscore-dangle */
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const keys = ['card', 'wrapper', 'handler'];
const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(keys);

const DraggableCardTheme = defineMultiStyleConfig({
  baseStyle: ({ isDragging, isOverlay }) => {
    const style: Record<string, any> = {
      card: {
        _hover: {
          borderColor: isDragging ? undefined : 'border/regular',
        },
      },
      wrapper: {
        position: 'relative',
        padding: '16',
        paddingInlineStart: '32',
        display: 'flex',
        visibility: isDragging ? 'hidden' : 'visible',
      },
      handler: {
        cursor: isOverlay ? 'grabbing' : 'grab',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        padding: '8',
        borderStartRadius: 7,
        color: 'icon/tertiary',
        _hover: {
          backgroundColor: isOverlay ? 'background/active' : 'background/hover',
          color: 'icon/secondary',
        },
      },
    };

    if (isDragging) {
      style.card.backgroundColor = 'background/secondary';
      style.card.borderColor = 'border/strong';
      style.card.borderStyle = 'dashed';
    }
    if (isOverlay) {
      style.card._hover = {
        borderColor: 'border/strong',
        boxShadow: 'large',
      };
    }

    return style;
  },
});

export default DraggableCardTheme;
